export const dashboardConstants = {
     graphType: {
          DONUT: "donut",
          LINE: "line",
          CAROUSEL: "carousel",
          COMMUNICATIONS: "communications",
          COLUMN: "column",
     },

     userTypes: [
          { value: "0", label: "All" },
          { value: "1", label: "Equipe" },
          { value: "3", label: "TLC" },
     ],

     DASHBOARD_GET_DASHBOARD_SUMMARY_REQUEST:
          "DASHBOARD_GET_DASHBOARD_SUMMARY_REQUEST",
     DASHBOARD_GET_DASHBOARD_SUMMARY_COMPLETE:
          "DASHBOARD_GET_DASHBOARD_SUMMARY_COMPLETE",

     DASHBOARD_GET_PARTICIPANT_ACTIVATION_SUMMARY_REQUEST:
          "DASHBOARD_GET_PARTICIPANT_ACTIVATION_SUMMARY_REQUEST",
     DASHBOARD_GET_PARTICIPANT_ACTIVATION_SUMMARY_COMPLETE:
          "DASHBOARD_GET_PARTICIPANT_ACTIVATION_SUMMARY_COMPLETE",

     DASHBOARD_GET_TLC_PARTICIPANT_ACTIVATION_SUMMARY_REQUEST:
     "DASHBOARD_GET_TLC_PARTICIPANT_ACTIVATION_SUMMARY_REQUEST",
     DASHBOARD_GET_TLC_PARTICIPANT_ACTIVATION_SUMMARY_COMPLETE:
          "DASHBOARD_GET_TLC_PARTICIPANT_ACTIVATION_SUMMARY_COMPLETE",



     DASHBOARD_GET_REWARD_ISSUED_BY_CAMPAIGN_REQUEST:
          "DASHBOARD_GET_REWARD_ISSUED_BY_CAMPAIGN_REQUEST",
     DASHBOARD_GET_REWARD_ISSUED_BY_CAMPAIGN_COMPLETE:
          "DASHBOARD_GET_REWARD_ISSUED_BY_CAMPAIGN_COMPLETE",

     DASHBOARD_GET_PARTICIPANT_LOGIN_SUMMARY_REQUEST:
          "DASHBOARD_GET_PARTICIPANT_LOGIN_SUMMARY_REQUEST",
     DASHBOARD_GET_PARTICIPANT_LOGIN_SUMMARY_COMPLETE:
          "DASHBOARD_GET_PARTICIPANT_LOGIN_SUMMARY_COMPLETE",

     DASHBOARD_GET_CAMPAIGN_PAGE_VIEW_SUMMARY_REQUEST:
          "DASHBOARD_GET_CAMPAIGN_PAGE_VIEW_SUMMARY_REQUEST",
     DASHBOARD_GET_CAMPAIGN_PAGE_VIEW_SUMMARY_COMPLETE:
          "DASHBOARD_GET_CAMPAIGN_PAGE_VIEW_SUMMARY_COMPLETE",

     DASHBOARD_GET_COMMS_PAGE_VIEW_REQUEST:
          "DASHBOARD_GET_COMMS_PAGE_VIEW_REQUEST",
     DASHBOARD_GET_COMMS_PAGE_VIEW_COMPLETE:
          "DASHBOARD_GET_COMMS_PAGE_VIEW_COMPLETE",

     DASHBOARD_GET_EMAIL_DISPATCH_SUMMARY_REQUEST:
          "DASHBOARD_GET_EMAIL_DISPATCH_SUMMARY_REQUEST",
     DASHBOARD_GET_EMAIL_DISPATCH_SUMMARY_COMPLETE:
          "DASHBOARD_GET_EMAIL_DISPATCH_SUMMARY_COMPLETE",

     DASHBOARD_GET_EMAIL_TRACKING_SUMMARY_REQUEST:
          "DASHBOARD_GET_EMAIL_TRACKING_SUMMARY_REQUEST",
     DASHBOARD_GET_EMAIL_TRACKING_SUMMARY_COMPLETE:
          "DASHBOARD_GET_EMAIL_TRACKING_SUMMARY_COMPLETE",

     GET_DEVICED_USED_SUMMARY_REQUEST: "GET_DEVICED_USED_SUMMARY_REQUEST",
     GET_DEVICED_USED_SUMMARY_COMPLETE: "GET_DEVICED_USED_SUMMARY_COMPLETE",

     DASHBOARD_GET_Q4_OILMASTER_SUMMARY_REQUEST:
          "DASHBOARD_GET_Q4_OILMASTER_SUMMARY_REQUEST",
     DASHBOARD_GET_Q4_OILMASTER_SUMMARY_COMPLETE:
          "DASHBOARD_GET_Q4_OILMASTER_SUMMARY_COMPLETE",

     DASHBOARD_GET_WEAR_TEER_SUMMARY_REQUEST:
          "DASHBOARD_GET_WEAR_TEER_SUMMARY_REQUEST",
     DASHBOARD_GET_WEAR_TEER_SUMMARY_COMPLETE:
          "DASHBOARD_GET_WEAR_TEER_SUMMARY_COMPLETE",

     DASHBOARD_GET_ABUDAHBI_SUMMARY_REQUEST:
          "DASHBOARD_GET_ABUDAHBI_SUMMARY_REQUEST",
     DASHBOARD_GET_ABUDAHBI_SUMMARY_COMPLETE:
          "DASHBOARD_GET_ABUDAHBI_SUMMARY_COMPLETE",

     DASHBOARD_GET_AREA_LIST_REQUEST: "DASHBOARD_GET_AREA_LIST_REQUEST",
     DASHBOARD_GET_AREA_LIST_COMPLETE: "DASHBOARD_GET_AREA_LIST_COMPLETE",

     DASHBOARD_GET_TLC_AREA_LIST_REQUEST: "DASHBOARD_GET_TLC_AREA_LIST_REQUEST",
     DASHBOARD_GET_TLC_AREA_LIST_COMPLETE: "DASHBOARD_GET_TLC_AREA_LIST_COMPLETE",

     DASHBOARD_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_REQUEST:"DASHBOARD_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_REQUEST",
     DASHBOARD_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_COMPLETE:"DASHBOARD_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_COMPLETE",

     DASHBOARD_GET_NOTIFICATIONS_REQUEST:"DASHBOARD_GET_NOTIFICATIONS_REQUEST",
     DASHBOARD_GET_NOTIFICATIONS_COMPLETE:"DASHBOARD_GET_NOTIFICATIONS_COMPLETE",

     DASHBOARD_DELETE_NOTIFICATIONS_REQUEST:"DASHBOARD_DELETE_NOTIFICATIONS_REQUEST",
     DASHBOARD_DELETE_NOTIFICATIONS_COMPLETE:"DASHBOARD_DELETE_NOTIFICATIONS_COMPLETE",

     DASHBOARD_REWARD_ISSUED_BY_DOWNLOAD_REQUEST:
     "DASHBOARD_REWARD_ISSUED_BY_DOWNLOAD_REQUEST",

     DASHBOARD_REWARD_ISSUED_BY_DOWNLOAD_COMPLETE:
     "DASHBOARD_REWARD_ISSUED_BY_DOWNLOAD_COMPLETE",

     DASHBOARD_PARTICIPANT_ACTIVATION_DOWNLOAD_REQUEST:
     "DASHBOARD_PARTICIPANT_ACTIVATION_DOWNLOAD_REQUEST",
     
     DASHBOARD_PARTICIPANT_ACTIVATION_DOWNLOAD_COMPLETE:
     "DASHBOARD_PARTICIPANT_ACTIVATION_DOWNLOAD_COMPLETE",

     DASHBOARD_USER_LOGIN_SUMMARY_DOWNLOAD_REQUEST:
     "DASHBOARD_USER_LOGIN_SUMMARY_DOWNLOAD_REQUEST",
     
     DASHBOARD_USER_LOGIN_SUMMARY_DOWNLOAD_COMPLETE:
     "DASHBOARD_USER_LOGIN_SUMMARY_DOWNLOAD_COMPLETE",

     DASHBOARD_EMAIL_TRACKING_DOWNLOAD_REQUEST:
     "DASHBOARD_EMAIL_TRACKING_DOWNLOAD_REQUEST",
     
     DASHBOARD_EMAIL_TRACKING_DOWNLOAD_COMPLETE:
     "DASHBOARD_EMAIL_TRACKING_DOWNLOAD_COMPLETE",

     DASHBOARD_EMAIL_DISPATCH_DOWNLOAD_REQUEST:
     "DASHBOARD_EMAIL_DISPATCH_DOWNLOAD_REQUEST",
     
     DASHBOARD_EMAIL_DISPATCH_DOWNLOAD_COMPLETE:
     "DASHBOARD_EMAIL_DISPATCH_DOWNLOAD_COMPLETE",

     DASHBOARD_COMMS_PAGE_VIEW_DOWNLOAD_REQUEST:
     "DASHBOARD_COMMS_PAGE_VIEW_DOWNLOAD_REQUEST",
     
     DASHBOARD_COMMS_PAGE_VIEW_DOWNLOAD_COMPLETE:
     "DASHBOARD_COMMS_PAGE_VIEW_DOWNLOAD_COMPLETE",

     DASHBOARD_DEVICED_USED_SUMMARY_DOWNLOAD_REQUEST:
     "DASHBOARD_DEVICED_USED_SUMMARY_DOWNLOAD_REQUEST",
     
     DASHBOARD_DEVICED_USED_SUMMARY_DOWNLOAD_COMPLETE:
     "DASHBOARD_DEVICED_USED_SUMMARY_DOWNLOAD_COMPLETE",

     DASHBOARD_CAMPAIGN_PAGE_VIEW_SUMMARY_DOWNLOAD_REQUEST:
     "DASHBOARD_CAMPAIGN_PAGE_VIEW_SUMMARY_DOWNLOAD_REQUEST",
     
     DASHBOARD_CAMPAIGN_PAGE_VIEW_SUMMARY_DOWNLOAD_COMPLETE:
     "DASHBOARD_CAMPAIGN_PAGE_VIEW_SUMMARY_DOWNLOAD_COMPLETE",

     DASHBOARD_PARTICIPANTS_SILDERCARD_DOWNLOAD_REQUEST: 
     "DASHBOARD_PARTICIPANTS_SILDERCARD_DOWNLOAD_REQUEST",

     DASHBOARD_PARTICIPANTS_SILDERCARD_DOWNLOAD_COMPLETE:
     "DASHBOARD_PARTICIPANTS_SILDERCARD_DOWNLOAD_COMPLETE",

     DASHBOARD_LOCATION_SILDERCARD_DOWNLOAD_REQUEST: 
     "DASHBOARD_LOCATION_SILDERCARD_DOWNLOAD_REQUEST",

     DASHBOARD_LOCATION_SILDERCARD_DOWNLOAD_COMPLETE:
     "DASHBOARD_LOCATION_SILDERCARD_DOWNLOAD_COMPLETE",

     DASHBOARD_GET_MOST_ACTIVE_DETAILS_CHART_REQUEST:
     "DASHBOARD_GET_MOST_ACTIVE_DETAILS_CHART_REQUEST",

     DASHBOARD_GET_MOST_ACTIVE_DETAILS_CHART_COMPLETE:
     "DASHBOARD_GET_MOST_ACTIVE_DETAILS_CHART_COMPLETE"
     
};
